export { default } from './FlagGolf'
